import React from "react";

const old = ["1950", "1960", "1970", "1980", "1990", "2000", "2010", "2020"];
const future = ["2030", "2040", "2050", "2060", "2070", "2080", "2090", "..."];

function PastYears() {
  const path = window.location.pathname;
  return (
    <div className="center-box">
      <div
        className={`${
          path === "/archive" ? "red-background" : "black-background"
        } bottom center-box`}
      >
        <div className="year-side-margin full-container spaced-and-center-box">
          {old.map((year) => {
            return <div className="year-font color-white">{year}</div>;
          })}
        </div>
      </div>
    </div>
  );
}

export function RedPastYears() {
  return (
    <div className="center-box">
      <div className="red-background bottom center-box">
        <div className="year-side-margin full-container spaced-and-center-box">
          {old.map((year) => {
            return <div className="year-font color-white">{year}</div>;
          })}
        </div>
      </div>
    </div>
  );
}

export function FutureYears() {
  return (
    <div className="center-box">
      <div className="black-background-future year-top center-box small-rotate home-layer-up">
        <div className="year-side-margin full-container spaced-and-center-box">
          {future.map((year) => {
            return <div className="year-font color-white">{year}</div>;
          })}
        </div>
      </div>
    </div>
  );
}

export function RedFutureYears() {
  return (
    <div className="center-box">
      <div className="red-background-future year-top center-box small-rotate home-layer-up">
        <div className="year-side-margin full-container spaced-and-center-box">
          {future.map((year) => {
            return <div className="year-font color-white">{year}</div>;
          })}
        </div>
      </div>
    </div>
  );
}

export default PastYears;
